// Piccole utilità di testo della pagina pubblica.

/**
 * Mette in maiuscolo la prima lettera: serve quando una data scritta in minuscolo
 * ("sabato 24 ottobre alle ore 16:00") apre una frase.
 */
export function maiuscolaIniziale(testo: string): string {
  return testo.charAt(0).toLocaleUpperCase('it-IT') + testo.slice(1);
}
